// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__cJGPA","modalForm":"UpgradeEpcsModal_modalForm__23smZ","modalFooter":"UpgradeEpcsModal_modalFooter__2Ou0L"};